import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess204005Status: 'idle',
    startProcess204005Error: undefined as any,
    loadUserParamsProcess204005Status: 'idle',
    loadUserParamsProcess204005Error: undefined as any,

    process204005List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess204005 = createAsyncThunk('process204005Slice/startProcess204005', async ({ process204005 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess204005/`,
        prepareData(process204005),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess204005Status } = getState().process204005Slice
        return startProcess204005Status !== 'pending'
    }
})

export const loadUserParamsProcess204005 = createAsyncThunk('process204005Slice/loadUserParamsProcess204005', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess204005/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess204005Status } = getState().process204005Slice
        return loadUserParamsProcess204005Status !== 'pending'
    }
})

const Process204005Slice = createSlice({
    name: 'process204005Slice',
    initialState,
    reducers: {
        resetstartProcess204005: (state) => {
            state.job = undefined
            state.startProcess204005Error = undefined
        },
        resetstartProcess204005Error: (state) => {
            state.startProcess204005Error = undefined
        },
        resetloadUserParamsProcess204005: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess204005Error = undefined
        },
        resetloadUserParamsProcess204005Error: (state) => {
            state.loadUserParamsProcess204005Error = undefined
        },
        removeFromProcess204005ListById: (state, action) => {
            state.process204005List = state.process204005List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess204005ListByIds: (state, action) => {
            state.process204005List = state.process204005List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process204005List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess204005Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process204005List = []
            state.startProcess204005Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess204005.pending, (state) => {
            state.startProcess204005Status = 'pending'
            state.startProcess204005Error = undefined
        })
        builder.addCase(startProcess204005.fulfilled, (state, action) => {
            state.startProcess204005Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess204005.rejected, (state, action) => {
            state.startProcess204005Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess204005Error = action.error.message
            } else {
                state.startProcess204005Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess204005.pending, (state) => {
            state.loadUserParamsProcess204005Status = 'pending'
            state.loadUserParamsProcess204005Error = undefined
        })
        builder.addCase(loadUserParamsProcess204005.fulfilled, (state, action) => {
            state.loadUserParamsProcess204005Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess204005.rejected, (state, action) => {
            state.loadUserParamsProcess204005Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess204005Error = action.error.message
            } else {
                state.loadUserParamsProcess204005Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess204005,
    resetstartProcess204005Error,
    resetloadUserParamsProcess204005,
    resetloadUserParamsProcess204005Error,
    removeFromProcess204005ListById,
    removeFromProcess204005ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process204005Slice.actions
export default Process204005Slice.reducer
